module.exports = __webpack_public_path__ + "static/bnr_wide@3x-7ec52c543eceb5085fd6ee290cbc4fa1.png";